document.addEventListener("DOMContentLoaded", function () {
  const leftPanelItems = document.querySelectorAll(".left-panel div");
  const rightPanelImage = document.querySelector(".right-panel img");

  leftPanelItems.forEach((el) => {
    el.addEventListener("mouseover", function () {
      if (!el.classList.contains("active")) {
        handleEvent.call(el);
      }
    });

    el.addEventListener("click", function () {
      if (!el.classList.contains("active")) {
        handleEvent.call(el);
      }
    });
  });

  const handleEvent = function () {
    const image = this.getAttribute("data-image");
    const altText = this.getAttribute("data-image-alt") || "zdjęcie";

    if (rightPanelImage) {
      rightPanelImage.src = image;
      rightPanelImage.alt = altText;
    }

    leftPanelItems.forEach((item) => item.classList.remove("active"));
    this.classList.add("active");
  };
});
